import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  InputNumber,
  Modal,
  notification
} from "antd";
import moment from "moment";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const PosTransactionTableFilter = (props) => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [filterQuery, setFilterQuery] = useState();
  const [filterModel, setFilterModel] = useState();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [operationTypeSelect, setOperationTypeSelect] = useState({
    data: [],
    loading: false,
  });
  const [currencyLlist, setCurrencyList] = useState([]);


  useEffect(() => {
    getBanks();
    RequestHandler.get(`/TenantAccount/CurrencyBankListTotal`).then(
      (response) => {
        var newList = [];
        response.map((item) => {
          newList.push(item.currencyId);
        })
        setCurrencyList(newList);
      }
    );
  }, []);
  
  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

   const getBanks = () => {
     setBankSelect({
       ...bankSelect,
       loading: true,
     });

     RequestHandler.get(`/Bank/GetFilterBank`).then(
       (response) => {
         setBankSelect({
           data: response,
           loading: false,
         });
       }
     );
   };
   const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const onFinish = (values) => {
    {
      var dayDifference=0;
      if(values.paymentDateRange !== undefined){
        const startMoment = moment(values.paymentDateRange[0]);
        const endMoment = moment(values.paymentDateRange[1]);
        
        dayDifference = endMoment.diff(startMoment, 'days');
      }
      

      var model = {};
      let query = "";
      const conditions = [];

      if (values.bankId) {
        model.bankId = values.bankId;
      }
      
      if (values.accountNumber) {
        conditions.push(`Contains(accountNumber, '${values.accountNumber}')`);
      }
      if (values.type) {
        conditions.push(`Contains(type, '${values.type}')`);
      }
      if (values.name) {
        conditions.push(`Contains(name, '${values.name}')`);
      }

      if (values.iban) {
        conditions.push(`Contains(iban, '${values.iban}')`);
      }
      if(props.amountModel){
        
        model.amountMin = values.amountMin === undefined || values.amountMin === null ? null : values.amountMin;
        model.amountMax = values.amountMax === undefined || values.amountMax === null ? null : values.amountMax;
        
        model.amountMinUSD = values.amountMinUSD === undefined || values.amountMinUSD === null ? null : values.amountMinUSD;
        model.amountMaxUSD = values.amountMaxUSD === undefined || values.amountMaxUSD === null ? null : values.amountMaxUSD;
        
        model.amountMinEUR = values.amountMinEUR === undefined || values.amountMinEUR === null ? null : values.amountMinEUR;
        model.amountMaxEUR = values.amountMaxEUR === undefined || values.amountMaxEUR === null ? null : values.amountMaxEUR;
        
        model.amountMinGBP = values.amountMinGBP === undefined || values.amountMinGBP === null ? null : values.amountMinGBP;
        model.amountMaxGBP = values.amountMaxGBP === undefined || values.amountMaxGBP === null ? null : values.amountMaxGBP;
        
        model.amountMaxXAU = values.amountMaxXAU === undefined || values.amountMaxXAU === null ? null : values.amountMaxXAU;
        model.amountMinXAU = values.amountMinXAU === undefined || values.amountMinXAU === null ? null : values.amountMinXAU;

        model.amountMaxAUD = values.amountMaxAUD === undefined || values.amountMaxAUD === null ? null : values.amountMaxAUD;
        model.amountMinAUD = values.amountMinAUD === undefined || values.amountMinAUD === null ? null : values.amountMinAUD;

      }
      else{
        if (values.amountMin) {
          conditions.push(`amount Ge ${values.amountMin}`);
        }
  
        if (values.amountMax) {
          conditions.push(`amount Le ${values.amountMax}`);
        }

        if (values.amountMinUSD) {
          conditions.push(`amountUSD Ge ${values.amountMinUSD}`);
        }
  
        if (values.amountMaxUSD) {
          conditions.push(`amountUSD Le ${values.amountMaxUSD}`);
        }


        if (values.amountMinAUD) {
          conditions.push(`amountAUD Ge ${values.amountMinAUD}`);
        }
  
        if (values.amountMaxAUD) {
          conditions.push(`amountAUD Le ${values.amountMaxAUD}`);
        }

        if (values.amountMinXAU) {
          conditions.push(`amountXAU Ge ${values.amountMinXAU}`);
        }
  
        if (values.amountMaxXAU) {
          conditions.push(`amountXAU Le ${values.amountMaxXAU}`);
        }


        if (values.amountMinEUR) {
          conditions.push(`amountEUR Ge ${values.amountMinEUR}`);
        }
  
        if (values.amountMaxEUR) {
          conditions.push(`amountEUR Le ${values.amountMaxEUR}`);
        }

        if (values.amountMinGBP) {
          conditions.push(`amountGBP Ge ${values.amountMinGBP}`);
        }
  
        if (values.amountMaxGBP) {
          conditions.push(`amountGBP Le ${values.amountMaxGBP}`);
        }
      }

      if (values.paymentDateRange) {
        const [startDate, endDate] = values.paymentDateRange;
        model.endDate = endDate;
        model.startDate = startDate;
      }
      
      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      
      if(props.monthly === true){
        if (props.onFinishFilter) props.onFinishFilter(query,model);
      }else if (dayDifference < 31 || dayDifference === 0){
        if (props.onFinishFilter) props.onFinishFilter(query,model);
      }
      else{
        model.isExcel = true;
        model.email = email;
        setFilterQuery(query);
        setFilterModel(model);
        setIsModalVisible(true);
      }
     
    }
  };
  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };
  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const mailTypeError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Girilen e-mail formatı hatalı.",
      duration: 2,
    });
  };
  const sendingEmail = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Excel'iniz hazırlanıp size email ile gönderilecektir.",
      duration: 5,
    });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const sendMail = () => {
    setLoading(true);
    var isValid = validateEmail(email);
    if(!isValid){
      mailTypeError('error')
      setLoading(false);
    }else{
      filterModel.email = email;
      if (props.onFinishFilter) props.onFinishFilter(filterQuery,filterModel);
      sendingEmail('success');
      setTimeout(() => {
      setIsModalVisible(false);
      setLoading(false);
        
      }, 2000);
    }
  };
  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="tenantFilter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
              {!props.isAccountFilter ?
               <Col xs={24} md={12} lg={6}>
               <Form.Item name="bankId" label="Banka :">
                 <Select
                   allowClear
                   showSearch
                   placeholder="Tümü"
                   loading={bankSelect.loading}
                   filterOption={(input, option) =>
                     option.props.children
                       .toLocaleLowerCase("tr-TR")
                       .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                   }
                 >
                   {bankSelect.data.map((item) => (
                     <Select.Option key={item.text} value={item.text}>
                       {item.value}
                     </Select.Option>
                   ))}
                 </Select>
               </Form.Item>
             </Col> 
                  : null
                }
               
                {props.isAccountFilter ?
                 <Col xs={24} md={12} lg={6}>
                 <Form.Item name="accountNumber" label="Hesap Numarası :">
                     <Input placeholder="Hesap Numarası" />
                   </Form.Item>
                 </Col>
                  : null
                }
                 {props.isAccountFilter ?
                 <Col xs={24} md={12} lg={6}>
                 <Form.Item name="iban" label="Iban :">
                     <Input placeholder="Iban"  />
                   </Form.Item>
                 </Col>
                  : null
                }

            {props.isAccountFilter ?
              <Col xs={24} md={12} lg={6}>
                              <Form.Item name="type" label="Tip :">
                                <Select
                                  allowClear
                                  placeholder="Tümü"
                                >
                                  <Select.Option key="0" value="Vadesiz">Vadesiz</Select.Option>
                                  <Select.Option key="1" value="Kredi">Kredi</Select.Option>
                                  <Select.Option key="2" value="Vadeli">Vadeli</Select.Option>
                                </Select>
                              </Form.Item>
                            </Col>

            : null
            }
            {props.isAccountFilter ?
              <Col xs={24} md={12} lg={6}>
                              <Form.Item name="name" label="Hesap Adı :">
                                <Input placeholder="Hesap Adı"  />
                              </Form.Item>
                            </Col>

            : null
            }
              {currencyLlist.includes(1) ?
      
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                :null }
                {currencyLlist.includes(2) ?
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="USD Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMinUSD">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMaxUSD">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                :null }
                {currencyLlist.includes(3) ?
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="EUR Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMinEUR">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMaxEUR">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                :null }
                {currencyLlist.includes(4) ?
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="GBP Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMinGBP">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMaxGBP">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                :null }
                {currencyLlist.includes(11) ?

                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="XAU Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMinXAU">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMaxXAU">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                :null }
                {currencyLlist.includes(14) ?
                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="AUD Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMinAUD">
                            <InputNumber placeholder="Min" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMaxAUD">
                            <InputNumber placeholder="Max" style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                :null }
                {!props.isAccountFilter ?
                 <Col xs={24} md={12} lg={6}>
                 <Form.Item name="paymentDateRange" label="Bakiye Tarihi :">
                   <DatePicker.RangePicker   
                    picker={props.monthly ? "month" : "date"}
                    format={props.monthly ? "MMMM YYYY" : "DD.MM.YYYY"} 
                    disabledDate={(current) => {
                      if(props.monthly){
                        return moment().add(0, 'days')  <= current 
                      }
                      else{
                        return moment().add(-1, 'days')  < current 
                      }
                      
                      }}
                    />
                 </Form.Item>
               </Col>
                  : null
                }
               

              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
      <Modal
          title="GünSonu Excel"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={false}
        >
          {/* <Spin spinning={loading}> */}
            <Row>
              <Col span={24}>Varsayılan olarak 15 günlük veri listelenmektedir. 30 günlük aralıklar ile filtreleme yapabilir daha geniş tarihler için mailinize Excel alabilirsiniz</Col>
              <Col span={18} style={{marginTop:'9%'}}>
                <Form.Item
                  label="Mail Adresi"
                  name="Email"
                  style={{ width: "100%" }}
                >
                  <Input value={email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={6} style={{marginTop:'9%'}}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    Gönder
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          {/* </Spin> */}
        </Modal>
    </Row>
  );
};
export default PosTransactionTableFilter;
